import template from './_form.pug'

export default Vue.extend({
  template: template(),
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaving: false,
      isLoadingAccounts: false,
      errors: {
        name: null,
        tableName: null,
        rule: null,
        accountId: null
      },
      form: {
        name: '',
        tableName: '',
        rule: '',
        accountId: null
      },
      accountOptions: []
    }
  },
  watch: {
    initialData: {
      handler(newData) {
        if(newData && Object.keys(newData).length) {
          const cleanData = newData.data || newData;

          Object.keys(this.form).forEach(key => {
            if (cleanData[key] !== undefined && cleanData[key] !== null) {
              this.form[key] = cleanData[key];
            }
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.applyInitialData();
    this.fetchAccounts();
  },
  methods: {
    t(key) {
      return this.$t(`aiInfinityRules.form.${key}`);
    },
    applyInitialData() {
      const cleanData = this.initialData && (this.initialData.data || this.initialData)

      if (!cleanData || !Object.keys(cleanData).length) return

      Object.keys(this.form).forEach(key => {
        if (cleanData[key] !== undefined && cleanData[key] !== null) {
          this.form[key] = cleanData[key]
        }
      })
    },
    fetchAccounts() {
      this.isLoadingAccounts = true;

      API.laiaAccounts.index()
        .then(({data}) => {
          const accounts = data || [];
          this.accountOptions = accounts.map(account => ({
            value: account.id,
            label: account.name || account.id
          }));
        })
        .catch(error => {
          console.error('Error al cargar las cuentas:', error);
          this.$notifications.error(this.t('errors.loadAccounts'));
        })
        .finally(() => {
          this.isLoadingAccounts = false;
        });
    },
    cancel() {
      this.$router.push({ name: 'ai-infinity-rules-list' });
    },
    validate() {
      let isValid = true;
      this.errors = {
        name: null,
        tableName: null,
        rule: null,
        accountId: null
      };

      if (!this.form.name || this.form.name.toString().trim() === '') {
        this.errors.name = this.t('errors.required');
        isValid = false;
      } else if (this.form.name.length > 64) {
        this.errors.name = this.t('errors.nameLength');
        isValid = false;
      }

      if (!this.form.tableName || this.form.tableName.toString().trim() === '') {
        this.errors.tableName = this.t('errors.required');
        isValid = false;
      } else if (this.form.tableName.length > 100) {
        this.errors.tableName = this.t('errors.tableNameLength');
        isValid = false;
      }

      if (!this.form.rule || this.form.rule.toString().trim() === ''){
        this.errors.rule = this.t('errors.required');
        isValid = false;
      } else if (this.form.rule.length > 512) {
        this.errors.rule = this.t('errors.ruleLength');
        isValid = false;
      }

      if(!this.form.accountId) {
        this.errors.accountId = this.t('errors.required');
        isValid = false;
      }

      return isValid
    },
    submit() {
      if (!this.validate()) return;

      this.isSaving = true;

      const payload = {
        name: this.form.name,
        tableName: this.form.tableName,
        rule: this.form.rule,
        accountId: this.form.accountId
      };

      const recordId = this.$route.params.id ||
        this.initialData.id ||
        (this.initialData && this.initialData.data && this.initialData.data.id);

      const apiCall = this.isEdit
        ? API.aiInfinityRules.update(recordId, payload)
        : API.aiInfinityRules.create(payload);
      
      apiCall.then(() => {
        this.$notifications.success(
          this.isEdit ? this.t('success.updated') : this.t('success.created')
        );
        this.$router.push({ name: 'ai-infinity-rules-list' });
      }).catch(error => {
        console.error('Error guardando regla:', error);
        this.$notifications.error(this.t('errors.saveError'));
      }).finally(() => {
        this.isSaving = false;
      });
    }
  }
})